export default __webpack_public_path__ + "images/ce496ed835ab7ceb6905679157f1deb5.svg";